import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { useContent } from '../hooks/useContent';

const Footer = () => {
  const { t } = useContent('site');
  return (
    <footer className="bg-navy text-cream mt-24">
      <div className="max-w-[1440px] mx-auto px-8 md:px-14 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo mono />
            <p className="font-serif text-2xl md:text-3xl mt-8 leading-snug text-cream/95 max-w-lg">
              {t('footer.tagline')}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-sans text-[10px] tracking-[0.3em] text-cream/50 mb-5">{t('footer.sitemap_label')}</p>
            <ul className="space-y-2 font-serif text-lg">
              <li><Link to="/" className="hover:opacity-70">Home</Link></li>
              <li><Link to="/team" className="hover:opacity-70">Team</Link></li>
              <li><Link to="/advisory-services" className="hover:opacity-70">Advisory Services</Link></li>
              <li><Link to="/investment-solutions" className="hover:opacity-70">Investment Solutions</Link></li>
              <li><Link to="/contact" className="hover:opacity-70">Contact</Link></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-sans text-[10px] tracking-[0.3em] text-cream/50 mb-5">{t('footer.offices_label')}</p>
            <div className="space-y-4">
              {(t('footer.offices') || []).map((o, i) => (
                <div key={i}>
                  <p className="font-serif text-lg">{o.name}</p>
                  <p className="font-sans text-sm text-cream/70">{o.address}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-cream/20 flex flex-col md:flex-row justify-between gap-4">
          <p className="font-sans text-xs text-cream/60">
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
          <p className="font-sans text-xs text-cream/60 whitespace-pre-wrap">
            {t('footer.contact_line')}
          </p>
        </div>

        <p className="font-sans text-[10px] text-cream/40 mt-8 leading-relaxed max-w-4xl">
          {t('footer.disclaimer')}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
